<template>
  <div class="w-full">
    <div class="steps-compra"> 
      <div class="pdv-container">
        <div class="content-steps">
          <div class="row no-gutters pb-4 steps-header-title-container-row">
            <div class="col-12 title-program-col">

              <div
                v-if="isEsencial(programSelectedTitle)"
                class="plan-selected-title"
                
              >
                <div class="border-ecesnsial">
                  <div class="border1"></div>
                  <div class="border2"></div>
                </div>
                <div class="d-flex flex-col ml-2">
                  <span>PROGRAMA </span>
                  <h2></h2>
                </div>
              </div>

              <div
                v-else
                :style="{borderLeft: '8px solid ' + getBorderTop(programSelectedTitle) }"
                class="plan-selected-title"
                :class="{
                  'plan-selected-title-red':
                    programSelectedTitle === 'Tradicional PSU 4° Medio',
                  'plan-selected-title-purple':
                    programSelectedTitle === 'Academia PSU Egresados'
                }"
              >
                <span>PROGRAMA {{ !selectedProgram.isPdvX ? 'P.T' : 'PDVX' }}</span>
                <h2>{{ programSelectedTitle }}</h2>
              </div>


              


            </div>
          </div>

          <div class="only-mobileBlock">
            <svg width="308" height="4" viewBox="0 0 308 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="74" height="4" rx="2" :fill="currentStep >= 1 ? '#592466' : '#B5B6BA'"/>
              <rect x="78" width="74" height="4" rx="2" :fill="currentStep >=  2 ? '#592466' : '#B5B6BA'"/>
              <rect x="156" width="74" height="4" rx="2" :fill="currentStep >= 3 ? '#592466' : '#B5B6BA'"/>
          
            </svg>
            <div class="steps-data">
              <span class="steps-data-text">{{currentStep}}/</span> 
              <span class="steps-data-text grey" style="margin-right: 3px;">4</span> 
              <span class="steps-data-text"> {{ getStepName }}</span>
            </div>
          </div>

          <div class="only-desktopBlock">
            <svg width="500" height="4" viewBox="0 0 500 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="122" height="4" rx="2" :fill="currentStep >= 1 ? '#592466' : '#B5B6BA'"/>
              <rect x="126" width="122" height="4" rx="2" :fill="currentStep >= 2 ? '#592466' : '#B5B6BA'"/>
              <rect x="252" width="122" height="4" rx="2" :fill="currentStep >= 3 ? '#592466' : '#B5B6BA'"/>

            </svg>
            <div class="steps-data">
              <span class="steps-data-text">{{currentStep}}/</span> 
              <span class="steps-data-text grey" style="margin-right: 3px;">4</span> 
              <span class="steps-data-text"> {{ getStepName }}</span>
            </div>
          </div>
          
      </div>

        
      </div>
    </div>

  </div>
</template>
  
  <script>
  export default {
    props: {
      currentStep: {
        default: 1
      },
  
      extraClass: {
        default: ''
      },
  
      stepsReceived: {
        default: () => {
          return [
            {
              status: 'pending',
              title: 'SELECCIÓN SEDE Y CURSO'
            },
            {
              status: 'pending',
              title: 'SELECCIÓN DE HORARIOS'
            },
            {
              status: 'pending',
              title: 'CONFIRMACIÓN DE CURSOS'
            },
            {
              status: 'pending',
              title: 'PAGO'
            }
          ];
        }
      }
    },
    data() {
      return {
        isMobile: false
      };
    },
    computed: {
      programSelectedTitle() {
        return this.$store.state.selectedProgram.name;
      },
      selectedProgram() {
        return this.$store.state.selectedProgram;
      },
      steps() {
        return this.stepsReceived.map((step, index) => {
          if (this.selectedProgram.isPdvX && index === 0) {
            step.title = step.title.replace(/SEDE Y /g, '');
          }
          index = index + 1;
          if (index < this.currentStep) {
            step.status = 'completed';
          } else if (index === this.currentStep) {
            step.status = 'active';
          } else {
            step.status = 'pending';
          }
          return step;
        });
      },
      getStepName(){
        switch (this.currentStep) {
          case 1:
            return 'Datos'
          case 2:
            return 'Confirmar compra'
            case 3:
          default:
            return  ''
        }
      }
    },
    methods:{
      getBorderTopOld(e) {
        if(!e) {
          return ''
        }
        e = e.toLowerCase() 
        if(e.includes('tradicional')) {
          return '#AE4239'
        }else if(e.includes('pdvx')) {
          return '#FFD100'
        }else if(e.includes('pdv online')){
          return '#592466'
        }else if(e.includes('mentoring') || e.includes('esencial')){
          return '#5E9C3D'
        }else {
          return '#b6b6b6'
        }
      },
      getBorderTop(f) {
        let e;
        const data = this.$store.state.formatProgramName
        if(!data || data.nivel2 == '') {
          return ''
        } else {
          e = data.nivel2.toLowerCase();
          if(e.includes('tradicional')) {
            return '#AE4239'
          }else if(e.includes('pdvx')) {
            return '#FFD100'
          }else if(e.includes('pdv online') || e.includes('online') ){
            return '#592466'
          }else if(e.includes('mentoring') || e.includes('esencial')){
            return '#5E9C3D'
          }else {
            return '#b6b6b6'
          }
        }
      },
      isEsencial(e){
        if(!e) {
          return false
        }
        e = e.toLowerCase() 
        return (e.includes('mentoring') || e.includes('esencial'))
      }
    }
  };
  </script>
  
  <style scoped lang="scss">
  
  .border-ecesnsial{
    
    margin-right: 8px;
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
  
    @media (max-width: 768px) {
      width: 8px;
    }
    @media (min-width: 769px) {
      width: 8px;
    }
  
    .border1{
      flex: 1;
      background: #AE4239;
    }
    .border2{
      flex: 1;
      background: #FFD100;
    }
  
  }
  
  .steps-compra{
    width: 100%;
    display: flex;
    flex-direction: column;
  
    .content-steps{
      display: flex;
      flex-direction: column;
  
      @media (max-width: 768px) {
        margin: 32px 24px 0 24px;
      }
      @media (min-width: 769px) {
        margin: 48px 76px 0 76px;
      }
  
      .steps-data{
        display: flex;
        margin-top: 8px;
        .steps-data-text {
          font-family: 'Poppins-Medium', sans-serif;
          font-size: 16px;
          line-height: 24px;
          color: $morado50;
  
          &.grey {
            color: $neutral40;
          }
        }
      }
  
    }
  }
  </style>
  
  <style scoped lang="scss">
  .steps-header {
    background: $gray-lighter;
    padding-top: 95px;
    @include media-breakpoint-down(sm) {
      padding-top: 65px;
    }
  }
  
  .steps-container {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    .steps-lines-container {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      height: 1.5px;
      width: 100%;
      background-color: $gray;
  
      .step-line {
        height: 1.5px;
        -webkit-box-flex: 1;
        flex-grow: 1;
        &.completed-line {
          background-color: $gray-light;
        }
        &:last-child {
          display: none;
        }
      }
    }
  
    .steps-index-container {
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      transform: translateY(-50%);
  
      .step-index {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        flex-direction: column;
        align-items: center;
        position: relative;
        .step-index-box {
          width: 27px;
          height: 27px;
          position: relative;
          background: #fff;
          border: 1.2px solid $gray;
          margin-bottom: 3px;
          span {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: $gray;
            font-size: 16px;
            @include font-medium-regular;
          }
        }
        p {
          font-size: 11px;
          @include alternative-light-regular;
          margin-bottom: 0;
          position: absolute;
          top: 30px;
          left: 50%;
          transform: translateX(-50%);
          width: auto;
          white-space: nowrap;
          @include media-breakpoint-down(sm) {
            display: none;
          }
        }
  
        &.active {
          .step-index-box {
            background: $black;
            border: 1.5px solid $yellow;
            span {
              color: $yellow;
              @include font-bold;
            }
          }
          p {
            @include alternative-bold;
          }
        }
  
        &.completed {
          .step-index-box {
            background: $gray-light;
            border: 1.5px solid transparent;
            span {
              color: #fff;
            }
          }
          p {
            @include alternative-light-regular;
            color: $gray-light;
          }
        }
      }
    }
  }
  
  .plan-selected-title {
    padding-left: 8px;
    span {
      font-family: 'Poppins-Regular', sans-serif;
      font-size: 16px;
      line-height: 24px;
      color: $neutral70;
    }
    h2 {
      font-family: 'Poppins-Bold', sans-serif;
      font-size: 27;
      line-height: 37px;
      margin-bottom: 0;
      /*text-transform: uppercase;*/
      color: $neutralBlack;
      @media screen and (max-width: 768px) {
       
      }
      @media screen and (min-width: 769px) {
       
      }
    }
    &.plan-selected-title-red {
      span {
        background: $red-light;
      }
  
      h2 {
        color: $red-2-light;
      }
    }
  
    &.plan-selected-title-purple {
      span {
        background: $purple-light;
      }
  
      h2 {
        color: $purple;
      }
    }
  }
  </style>
  